<template>
  <div id="AboutMeImage4" :class="sectionClass">
    <img src="/static/about-me/i24.webp" />
  </div>
</template>

<script>
import { isMobile } from '@/helpers'

export default {
  computed: {
    sectionClass() {
      return {
        section: !this.isMobile(),
        sectionMobile: this.isMobile(),
      }
    },
  },
  methods: {
    isMobile,
  },
}
</script>

<style lang="scss" scoped>
.section {
  width: 25%;
  padding-bottom: 25%;
}

.sectionMobile {
  width: 40%;
  padding-bottom: 55%;
}
</style>



// WEBPACK FOOTER //
// src/components/about-me/AboutMeImage4.vue